// @aide-title Site detail
// @aide-description A single site's details and folder tree, together with the users and groups that have access to it
// @aide-area Folder Structure
// @aide-area Users
// @aide-area Groups
// @aide-rule The site's folders are browsed inside this page — any segments after the site id are folder slugs
import React from "react";
import { MaplesPage } from "components/pages";
import { SiteDetails } from "features/Sites/SiteDetails";

const SiteDetailsPage = ({ match }) => {
  const siteId = match.params.id;
  return (
    <MaplesPage headerItems={["Sites"]}>
      <SiteDetails siteId={siteId} />
    </MaplesPage>
  );
};

export default SiteDetailsPage;
